import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton, FormControlLabel, FormControl, RadioGroup, Radio } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { RxCross2 } from "react-icons/rx";
import AddCommentClaim from "./addComment";
import CommentAttachments from "./commentAttachments";
import ClaimCommentList from "./commentList";
import { useUpdateClaimMutation } from "store/slices/apis/claimSlice";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
const tabs = ["Claim Information", "Documents"]

const EditClaimTracker = (props) => {
    const { open, handleClose, claimData, refetchCounts } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [updateClaim] = useUpdateClaimMutation()
    const [tabValue, setTabValue] = useState(0);

    const module = "Claim";

    const { data: claimStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const claimStatusData = claimStatusRes?.data || [];
    const claimStatusOptions = mapAndSortAlphabetically(claimStatusData);

    const { data: claimRaisedTypeRes } = useGetMasterDataQuery({ module: module, category: 'RaisedType', ProjectId: projectId });
    const claimRaisedTypeData = claimRaisedTypeRes?.data || [];
    const claimRaisedOptions = (claimRaisedTypeData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: claimAmountTypeRes } = useGetMasterDataQuery({ module: module, category: 'AmountType', ProjectId: projectId });
    const claimAmountTypeData = claimAmountTypeRes?.data || [];
    const amountOptions = (claimAmountTypeData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: claimCategoryRes } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: projectId });
    const claimCategoryData = claimCategoryRes?.data || [];
    const claimCategoryOptions = mapAndSortAlphabetically(claimCategoryData);

    const [initialFormData, setInitialFormData] = useState({
        category: "",
        claimaint: "",
        contractNo: "",
        status: "",
        documentRefNo: "",
        description: "",
        amountClaim: "",
        amountApproved: "",
        eotDaysClaimed: "",
        eotDayApproved: "",
        submittedDate: null,
        dueDate: null,
        responnseDate: null,
        resolutionDate: null,
        date: null,
        raisedType: "",
        projectId: projectId,
    });

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("YYYY-MM-DD");

    };

    useEffect(() => {
        if (claimData && open) {
            const formattedData = {
                category: claimData.claimCategory || "",
                claimaint: claimData.claimant || "",
                contractNo: claimData.contractNo || "",
                status: claimData.status || "",
                documentRefNo: claimData.documentRefNo || "",
                description: claimData.descriptionOfClaim || "",
                amountClaim: claimData.amountClaimed || "",
                amountApproved: claimData.amountApprovedOrSettled || "",
                eotDaysClaimed: claimData.eotDaysClaimed || "",
                eotDayApproved: claimData.eotDaysApproved || "",
                raisedType: claimData.raisedType || "",
                submittedDate: formatDateForInput(claimData.dateSubmitted),
                date: formatDateForInput(claimData.date),
                dueDate: formatDateForInput(claimData.dueDate),
                responnseDate: formatDateForInput(claimData.responseDate),
                resolutionDate: formatDateForInput(claimData.resolutionDate),
                projectId: projectId,
            };
            setInitialFormData(formattedData);
        }
    }, [claimData, open, projectId]);

    const validationSchema = Yup.object({
        category: Yup.string().required("Category field is required"),
        claimaint: Yup.string().required("Claimant field is required"),
        // contractNo: Yup.string().required("Contract No field is required"),
        status: Yup.string().required("Status field is required"),
        raisedType: Yup.string().required("Raised type is required"),
        // documentRefNo: Yup.string().required("Document Ref No field is required"),
        description: Yup.string().required("Description field is required"),
        amountClaim: Yup.number().required("Amount Claimed field is required"),
        // amountApproved: Yup.number().required("Amount Approved field is required"),
        // eotDaysClaimed: Yup.number().required("EOT Days Claimed field is required"),
        // eotDayApproved: Yup.number().required("EOT Day Approved field is required"),
        submittedDate: Yup.date().required("Submitted Date field is required"),
        // date: Yup.date().required("Date field is required"),
        // dueDate: Yup.date().required("Due Date field is required"),
        // responnseDate: Yup.date().required("Response Date field is required"),
        // resolutionDate: Yup.date().required("Resolution Date field is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        let reqBody = {
            claimId: claimData?.claimId,
            claimCategory: values?.category,
            projectCode: "string",
            claimant: values?.claimaint,
            contractNo: values?.contractNo,
            status: values?.status,
            documentRefNo: values?.documentRefNo,
            descriptionOfClaim: values?.description,
            amountClaimed: parseFloat(values?.amountClaim),
            raisedType: values?.raisedType,
            amountApprovedOrSettled: values?.amountApproved,
            eotDaysClaimed: values?.eotDaysClaimed ? parseInt(values.eotDaysClaimed) : null,
            eotDaysApproved: values?.eotDayApproved ? parseInt(values.eotDayApproved) : null,
            dateSubmitted: values?.submittedDate ? moment.utc(values?.submittedDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            date: values?.date ? moment.utc(values?.date, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            dueDate: values?.dueDate ? moment.utc(values?.dueDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            responseDate: values?.responnseDate ? moment.utc(values.responnseDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
            resolutionDate: values?.resolutionDate ? moment.utc(values.resolutionDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
        };

        console.log("Update Claim Request Body:", reqBody);

        try {
            const response = await updateClaim({ body: reqBody }).unwrap();
            openNotification("Claim updated successfully", "success");
            setSubmitting(false);
            refetchCounts()
            handleClose();

        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Dialog
            open={open}
            fullScreen
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    Edit Claim
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],

                    })}
                >
                    <RxCross2 size={30} color="#140F36" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <CustomTabs tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} />
                    {tabValue === 0 &&
                        <Grid container spacing={2}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={initialFormData}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                        setFieldTouched }) => (
                                        <form onSubmit={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid size={12}>
                                                    <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                        Claim Details
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Claim Category
                                                    </Typography>
                                                    <Select
                                                        name="category"
                                                        options={claimCategoryOptions}
                                                        value={claimCategoryOptions.find(opt => opt.value === String(values.category)) || null}
                                                        onChange={(option) => setFieldValue("category", option.value)}
                                                        onBlur={() => setFieldTouched("category", true)}
                                                        placeholder="Select Category"
                                                    />
                                                    {touched.category && errors.category && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.category}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Claimant</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="claimaint"
                                                        value={values.claimaint}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Claimant"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.claimaint && errors.claimaint && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.claimaint}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Contract No</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="contractNo"
                                                        value={values.contractNo}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Contract No"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.contractNo && errors.contractNo && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.contractNo}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Status
                                                    </Typography>
                                                    <Select
                                                        name="status"
                                                        options={claimStatusOptions}
                                                        value={claimStatusOptions.find(opt => opt.value === String(values.status)) || null}
                                                        onChange={(option) => setFieldValue("status", option.value)}
                                                        onBlur={() => setFieldTouched("status", true)}
                                                        placeholder="Select Status"

                                                    />
                                                    {touched.status && errors.status && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.status}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Raised Type
                                                    </Typography>
                                                    <Select
                                                        name="raisedType"
                                                        options={claimRaisedOptions}
                                                        value={claimRaisedOptions.find(opt => opt.value === String(values.raisedType)) || null}
                                                        onChange={(option) => setFieldValue("raisedType", option.value)}
                                                        onBlur={() => setFieldTouched("raisedType", true)}
                                                        placeholder="Select Raised Type"
                                                    />
                                                    {touched.raisedType && errors.raisedType && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.raisedType}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Document Ref No</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="documentRefNo"
                                                        value={values.documentRefNo}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Document Ref No"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.documentRefNo && errors.documentRefNo && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.documentRefNo}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 12 }}>
                                                    <Typography sx={labelTextStyle}>Description of Claim</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="description"
                                                        value={values.description}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        multiline
                                                        rows={3}
                                                        placeholder="Enter Description"

                                                        InputProps={{
                                                            sx: {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& textarea::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& textarea": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.description && errors.description && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.description}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Amount Claimed (INR Cr)</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="amountClaim"

                                                        value={values.amountClaim}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter Amount Claimed"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.amountClaim && errors.amountClaim && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.amountClaim}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Amount Approved/Settled</Typography>
                                                    <Select
                                                        name="amountApproved"
                                                        options={amountOptions}
                                                        value={amountOptions.find(opt => opt.value === String(values.amountApproved)) || null}
                                                        onChange={(option) => setFieldValue("amountApproved", option.value)}
                                                        onBlur={() => setFieldTouched("amountApproved", true)}
                                                        placeholder="Select Amount Type"
                                                    />
                                                    {touched.amountApproved && errors.amountApproved && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.amountApproved}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>EOT Days Claimed</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="eotDaysClaimed"

                                                        value={values.eotDaysClaimed}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter EOT Days Claimed"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.eotDaysClaimed && errors.eotDaysClaimed && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.eotDaysClaimed}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>EOT Day Approved</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="eotDayApproved"
                                                        value={values.eotDayApproved}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter EOT Day Approved"

                                                        InputProps={{
                                                            sx: {
                                                                height: "40px",
                                                                borderRadius: "8px",
                                                                backgroundColor: "#fff",
                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },
                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                        WebkitTextFillColor: "#0A0A0C",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.eotDayApproved && errors.eotDayApproved && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.eotDayApproved}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Date Submitted
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="submittedDate"
                                                        value={values.submittedDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth

                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.submittedDate && errors.submittedDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.submittedDate}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="date"
                                                        value={values.date}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.date && errors.date && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.date}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Due Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="dueDate"
                                                        value={values.dueDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth

                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.dueDate && errors.dueDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.dueDate}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Response Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="responnseDate"
                                                        value={values.responnseDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth

                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.responnseDate && errors.responnseDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.responnseDate}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Resolution Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="resolutionDate"
                                                        value={values.resolutionDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input) input.showPicker?.();
                                                        }}
                                                        fullWidth

                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: "#fff",
                                                                border: '1px solid',
                                                                borderColor: 'hsl(0, 0%, 80%)',
                                                                height: "40px",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "5px",
                                                            },
                                                        }}
                                                    />
                                                    {touched.resolutionDate && errors.resolutionDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.resolutionDate}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                <Grid size={12}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            gap: 2,
                                                        }}
                                                    >
                                                        <Button onClick={handleClose}
                                                            sx={{
                                                                textTransform: "none",
                                                                color: "#F15744",
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                borderRadius: "25px",
                                                                fontWeight: 500,
                                                                px: "20px",
                                                                py: "15px",
                                                            }}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            disabled={isSubmitting}
                                                            sx={{
                                                                backgroundColor: "#00344C",
                                                                borderRadius: "25px",
                                                                textTransform: "none",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#FFFFFF",
                                                                px: "20px",
                                                                py: "15px",
                                                                '&:disabled': {
                                                                    backgroundColor: '#cccccc',
                                                                }
                                                            }}
                                                        >
                                                            {isSubmitting ? "Updating..." : "Update"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    )}
                                </Formik>
                            </Grid>
                            <Grid
                                size={{ md: 6, xs: 12 }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: '90vh', // adjustable
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    overflow: "auto",
                                }}
                            >
                                <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                                    {/* Comment list */}
                                    <ClaimCommentList data={claimData} />
                                </Box>

                                <Box sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
                                    <AddCommentClaim data={claimData} />
                                </Box>
                            </Grid>
                        </Grid>
                    }

                    {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={claimData?.claimId} entityType="Claim" customId={claimData?.customId} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EditClaimTracker;